import MatchMedia from '../../../ui/MatchMedia/MatchMedia';
import ImageGalleryCarouselDesktop from '../ImageGalleryCarouselDesktop/v2';
import ImageGalleryCarouselMobile from '../ImageGalleryCarouselMobile/ImageGalleryCarouselMobile';

const ImageGalleryCarousel = (props) => {
  return (
    <MatchMedia
      content={{
        mobile: () => <ImageGalleryCarouselMobile {...props} />,
        tablet: () => <ImageGalleryCarouselMobile {...props} />,
        desktop: () => <ImageGalleryCarouselDesktop {...props} />,
      }}
    />
  );
};

export default ImageGalleryCarousel;
